import { timezoneDate } from '@/common/utils/DateManager';
import { addCartItem, updateCartItem } from './cartIdentity';

const expireTime = 1000 * 60 * 60 * 24;

const setCartWithTtl = (commit, cart) => {
  commit('setCart', cart);
  if (cart.length > 0) commit('setTtl', timezoneDate().getTime() + expireTime);
};

export default {
  ADD_CART: ({ commit, getters }, payload) => {
    const { storeNo = 0, cartItem = {} } = payload;
    const state = getters['getCart'];
    if (state.storeNo === 0 && storeNo !== 0) commit('setStoreNo', storeNo);
    if (Object.keys(cartItem).length > 0) {
      setCartWithTtl(commit, addCartItem(state.cart, cartItem));
    }
  },
  UPDATE_CART: ({ commit, getters }, payload) => {
    const { storeNo = 0, cartItem = {} } = payload;
    const state = getters['getCart'];

    if (state.storeNo === 0 && storeNo !== 0) commit('setStoreNo', storeNo);
    if (Object.keys(cartItem).length === 0) return;

    setCartWithTtl(commit, updateCartItem(state.cart, cartItem));
  },
  REMOVE_IS_DONE: ({ commit, getters }) => {
    const state = getters['getCart'];

    if (!state?.cart || !Array.isArray(state.cart)) return;

    // ✅ isDone 제거
    const cleaned = state.cart.map((item) => {
      const newItem = { ...item };
      if ('isDone' in newItem) delete newItem.isDone;
      return newItem;
    });

    // ✅ 반영
    commit('setCart', cleaned);

    // TTL 갱신 (유효기간 초기화)
    if (cleaned.length > 0) commit('setTtl', timezoneDate().getTime() + expireTime);
  }
};
